const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000',
};

export default config;